import React from 'react';

const OPTIONS = [
  { key: 'order_date', label: 'Date Created' },
  { key: 'event_date', label: 'Event Date' },
];

function DateModeToggle({ value, onChange }) {
  return (
    <div style={{
      display: 'inline-flex',
      background: 'var(--sl-bg-tertiary, #f2f4f7)',
      borderRadius: 8,
      padding: 2,
      position: 'relative',
      height: 32,
    }}>
      {OPTIONS.map(({ key, label }) => {
        const active = value === key;
        return (
          <button
            key={key}
            type="button"
            onClick={() => onChange(key)}
            style={{
              fontSize: 13,
              fontWeight: active ? 600 : 400,
              padding: '0 12px',
              borderRadius: 6,
              border: 'none',
              background: active ? 'var(--sl-bg-primary, #ffffff)' : 'transparent',
              color: active ? 'var(--sl-text-secondary, #344054)' : 'var(--sl-text-tertiary, #667085)',
              cursor: 'pointer',
              position: 'relative',
              zIndex: 1,
              boxShadow: active ? '0 1px 2px rgba(16, 24, 40, 0.06), 0 1px 3px rgba(16, 24, 40, 0.1)' : 'none',
              transition: 'all 0.15s ease',
              lineHeight: '28px',
            }}
          >
            {label}
          </button>
        );
      })}
    </div>
  );
}

export default DateModeToggle;
